import {BaseModel} from "../base.model";

export interface ExchangeGoods extends BaseModel {
  
}

export const defaultExchangeGoods: Readonly<ExchangeGoods> = {};